"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@headlessui/react");
var classnames_1 = require("classnames");
var Typography_1 = require("../Typography");
var styles_1 = require("./styles");
var RadioCard = function (_a) {
    var label = _a.label, helpText = _a.helpText, value = _a.value;
    return ((0, jsx_runtime_1.jsx)(react_1.RadioGroup.Option, __assign({ value: value, className: function (_a) {
            var checked = _a.checked, active = _a.active, disabled = _a.disabled;
            return (0, styles_1.getRadioCardClasses)({ checked: checked, active: active, disabled: disabled });
        } }, { children: function (_a) {
            var checked = _a.checked, disabled = _a.disabled;
            return ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "squid-flex squid-flex-col" }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ className: (0, classnames_1.default)({
                            'squid-text-alias-color-text-weaker': !disabled,
                            'squid-text-alias-color-text-on-active': !disabled && checked,
                            'squid-text-alias-color-text-disabled': disabled,
                            'squid-text-center ': !helpText || helpText.trim().length === 0,
                        }) }, { children: label })), helpText && ((0, jsx_runtime_1.jsx)(Typography_1.Body, __assign({ size: "sm", className: (0, classnames_1.default)({
                            'squid-text-alias-color-text-weakest': !disabled,
                            'squid-text-alias-color-text-disabled': disabled,
                        }) }, { children: helpText })))] })));
        } }), label));
};
exports.RadioCard = RadioCard;
